import {getDatabase, ref, off, onValue} from "firebase/database";

export class TTLiveUpdate {

    constructor(updateCallback, currentPageProvider, app) {
        this.updateRef = null
        this.updateCallback = updateCallback
        this.pageTypeProvider = currentPageProvider
        this.app = app
    }

    update(notificationGroup) {
        console.log("Updating to group", notificationGroup)

        let firebaseDB = getDatabase()

        // terminate existing
        let targetsDifferentGroup = this.updateRef && ((this.updateRef.toString() !== ref(firebaseDB, '/syncDb/' + notificationGroup).toString()));
        let newTargetIsNull = this.updateRef && notificationGroup === undefined;
        if (targetsDifferentGroup || newTargetIsNull) {
            console.log("Terminating notification", this.updateRef.toString());
            off(this.updateRef);
            this.updateRef = null;
        }

        if (notificationGroup === undefined)
            return

        // start new
        if (!this.updateRef) {
            console.log("Setup notification for", '/syncDb/' + notificationGroup);
            this.updateRef = ref(firebaseDB, '/syncDb/' + notificationGroup);

            let isInitialUpdate = true;

            onValue(this.updateRef, (snapshot) => {

                // skip the initial update
                if (isInitialUpdate) {
                    isInitialUpdate = false;
                    return;
                }

                this.handleUpdate(snapshot.val())
            });
        }
    }

    /* keep for test */
    inject(data) {
        console.log("Injecting", data)
        this.handleUpdate(data)
    }

    handleUpdate(snapshot) {
        // update avoidance for community-reporter
        let currentPage = this.pageTypeProvider();
        if ("community-reporter" === currentPage) {
            // skip page refresh if data is already up to date

            let comReporterPage = this.app.shadowRoot.getElementById("page");
            comReporterPage.refreshRequired(snapshot?.contentHash)
                .then((updateRequired) => {
                    if (updateRequired) {
                        console.debug("Content-Hash mismatch, triggering update");
                        this.updateCallback()
                    } else {
                        console.debug("Already up-to-date. No update required");
                    }
                })
        } else {
            // refresh data
            this.updateCallback()
        }
    }

}